import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { dateformat } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { ButtonFile, LoadingWidget } from '../../../../widgets';
import { FechaField } from '../../../accesos/components/FechaField';
import {
  getFileUrl,
  saveArchivosAction,
} from '../../../archivos/ArchivosAction';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { allUsuEntidadesAction } from '../../usu_entidades/UsuEntidadesAction';
import {
  allUsuariosAction,
  setActivoUsuariosAction,
  updatePerfilUsuariosAction,
} from '../UsuariosAction';

const FormUsuPerfilComponent = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const usuariosStore = Redux.useSelector((state) => state.usuarios);
  const { activo: activoEntidad, params: paramsEntidad } = Redux.useSelector(
    (state) => state.entidades,
  );
  const { isRoot } = Redux.useSelector((state) => state.login);

  const [usuario, setUsuario] = React.useState(usuariosStore.activo);

  const initData = {
    tipoDni: 'V',
    dni: '',
    pnombre: '',
    snombre: '',
    papellido: '',
    sapellido: '',
    fechaNacimiento: '',
    genero: 'M',
    tipoSangre: 'A0',
    internet: false,
    actividadExtcur: false,
    dniEscolar: false,
    idImgFoto: null,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    dni: false,
    pnombre: false,
    papellido: false,
    fechaNacimiento: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  const [fileImgFoto, setFileImgFoto] = React.useState();

  React.useEffect(() => {
    if (!usuario) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = usuario.perfil[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idImgFoto: usuario.perfil.avatar?.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      const perfil = await updatePerfilUsuariosAction(
        { dispatch, notify },
        usuario.perfil.id,
        data,
      );
      if (perfil) {
        setActivoUsuariosAction(dispatch, {
          ...usuario,
          perfil,
        });
      }
      setLoadingSave(false);
    }
  };

  const selectTipoDni = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.tipoDni.name}`}>
        {CONST.tipoDni.label}
      </InputLabel>
      <Select
        id={CONST.tipoDni.name}
        value={data.tipoDni}
        labelId={`label_${CONST.tipoDni.name}`}
        label={CONST.tipoDni.label}
        onChange={(e) =>
          _handleSetDataField(CONST.tipoDni.name, e.target.value)
        }
      >
        <MenuItem value="V">Cédula Venezolana</MenuItem>
        <MenuItem value="P">Pasaporte</MenuItem>
        <MenuItem value="E">Extranjero</MenuItem>
        <MenuItem value="CE">Cédula de escolar</MenuItem>
      </Select>
    </FormControl>
  );
  const selectGenero = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.genero.name}`}>
        {CONST.genero.label}
      </InputLabel>
      <Select
        id={CONST.genero.name}
        value={data.genero}
        labelId={`label_${CONST.genero.name}`}
        label={CONST.genero.label}
        onChange={(e) => _handleSetDataField(CONST.genero.name, e.target.value)}
      >
        <MenuItem value="M">Masculino</MenuItem>
        <MenuItem value="F">Femenino</MenuItem>
      </Select>
    </FormControl>
  );
  const selectTipoSangre = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.tipoSangre.name}`}>
        {CONST.tipoSangre.label}
      </InputLabel>
      <Select
        id={CONST.tipoSangre.name}
        value={data.tipoSangre}
        labelId={`label_${CONST.tipoSangre.name}`}
        label={CONST.tipoSangre.label}
        onChange={(e) =>
          _handleSetDataField(CONST.tipoSangre.name, e.target.value)
        }
      >
        <MenuItem value="A0">A-</MenuItem>
        <MenuItem value="A1">A+</MenuItem>
        <MenuItem value="B0">B-</MenuItem>
        <MenuItem value="B1">B+</MenuItem>
        <MenuItem value="AB0">AB-</MenuItem>
        <MenuItem value="AB1">AB+</MenuItem>
        <MenuItem value="O1">O+</MenuItem>
        <MenuItem value="O0">O-</MenuItem>
      </Select>
    </FormControl>
  );

  const isStudent = usuario.rol === 'student';

  return (
    <Box component="form">
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <LoadingWidget isLoading={loadingSave} isActivo={usuario} />
        </Grid>
        <Grid item xs={12} md={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              {}
              <ButtonFile
                id={'avatar'}
                onFile={async (file) => {
                  setFileImgFoto(file);
                  setLoadingSave(true);
                  try {
                    const res = await saveArchivosAction(dispatch, {
                      file,
                      isPublic: 't',
                      desc: 'Foto carnet',
                      nameIdField: 'idUser',
                      valueField: usuario.id,
                      field: 'avatar',
                    });
                    setUsuario({
                      ...usuario,
                      perfil: {
                        ...usuario.perfil,
                        avatar: res,
                      },
                    });
                    setActivoUsuariosAction(dispatch, {
                      ...usuario,
                      perfil: {
                        ...usuario.perfil,
                        avatar: res,
                      },
                    });
                    setFileImgFoto(null);
                    if (isRoot) {
                      await allUsuariosAction(dispatch, usuariosStore.params);
                    } else {
                      await allUsuEntidadesAction(dispatch, {
                        idEntidad: activoEntidad.id,
                        ...paramsEntidad,
                      });
                    }
                    if (res) {
                      setFileImgFoto(file);
                      setFileImgFoto(file);
                      setLoadingSave(false);
                      notify('Foto actualizada');
                    }
                  } catch (error) {
                    notify('Error al cargar la imagen', { error: true });
                  }
                }}
                file={fileImgFoto}
                text="Subir foto"
                sxc={{ marginTop: '5px' }}
                size="90%"
                name={usuario?.perfil.avatar?.nombre ?? 'Foto'}
                onDelete={() => setFileImgFoto(null)}
                src={!fileImgFoto && getFileUrl(usuario.perfil.avatar)}
              />
            </Grid>
            <Grid item xs={12} md={9}>
              <Grid container spacing={2}>
                {isStudent && (
                  <Grid item xs={12} md={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={data.dniEscolar}
                          onChange={(e) =>
                            _handleSetDataField(
                              CONST.dniEscolar.name,
                              e.target.checked,
                            )
                          }
                        />
                      }
                      label={CONST.dniEscolar.quest}
                    />
                  </Grid>
                )}
                <Grid item xs={12} md={6}>
                  {selectTipoDni}
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id={CONST.dni.name}
                    required
                    label={
                      data.dniEscolar
                        ? CONST.dniEscolar.family
                        : CONST.dni.label
                    }
                    value={data.dni}
                    onChange={(e) =>
                      _handleSetDataField(CONST.dni.name, e.target.value)
                    }
                    helperText={dataError.dni ? validMessage.required : null}
                    error={dataError.dni}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id={CONST.papellido.name}
                    required
                    label={CONST.papellido.label}
                    value={data.papellido}
                    onChange={(e) =>
                      _handleSetDataField(
                        CONST.papellido.name,
                        e.target.value.toUpperCase(),
                      )
                    }
                    helperText={
                      dataError.papellido ? validMessage.required : null
                    }
                    error={dataError.papellido}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id={CONST.sapellido.name}
                    label={CONST.sapellido.label}
                    value={data.sapellido}
                    onChange={(e) =>
                      _handleSetDataField(
                        CONST.sapellido.name,
                        e.target.value.toUpperCase(),
                      )
                    }
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id={CONST.pnombre.name}
                    required
                    label={CONST.pnombre.label}
                    value={data.pnombre}
                    onChange={(e) =>
                      _handleSetDataField(
                        CONST.pnombre.name,
                        e.target.value.toUpperCase(),
                      )
                    }
                    helperText={
                      dataError.pnombre ? validMessage.required : null
                    }
                    error={dataError.pnombre}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id={CONST.snombre.name}
                    label={CONST.snombre.label}
                    value={data.snombre}
                    onChange={(e) =>
                      _handleSetDataField(
                        CONST.snombre.name,
                        e.target.value.toUpperCase(),
                      )
                    }
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  {selectGenero}
                </Grid>
                <Grid item xs={12} md={6}>
                  <FechaField
                    views={['year', 'month', 'day']}
                    openTo="year"
                    botonCurrentDate={false}
                    label={CONST.fechaNacimiento.label}
                    value={data.fechaNacimiento}
                    error={dataError.fechaNacimiento}
                    onChange={(e) =>
                      _handleSetDataField(
                        CONST.fechaNacimiento.name,
                        dateformat(e, {}),
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  {selectTipoSangre}
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={data.internet}
                        onChange={(e) => {
                          _handleSetDataField(
                            CONST.internet.name,
                            e.target.checked,
                          );
                        }}
                      />
                    }
                    label={CONST.internet.quest}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={data.actividadExtcur}
                        onChange={(e) => {
                          _handleSetDataField(
                            CONST.actividadExtcur.name,
                            e.target.checked,
                          );
                        }}
                      />
                    }
                    label={CONST.actividadExtcur.quest}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text="ACTUALIZAR"
            disabled={loadingSave}
            blue
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormUsuPerfilComponent;
